import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeView.vue"),
  },
  {
    path: "/categorias",
    name: "categories",
    component: () => import("@/views/CategoriesView.vue"),
  },
  {
    path: "/categoria/:slug",
    name: "category",
    component: () => import("@/views/CategoryView.vue"),
    props: true,
  },
  {
    path: "/producto/:id",
    name: "product-detail",
    component: () => import("@/views/ProductDetailView.vue"),
  },
  {
    path: "/carrito",
    name: "cart",
    component: () => import("@/views/CartView.vue"),
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () => import("@/views/CheckoutView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si el navegador hace back/forward,
    // conserva la posición anterior.
    if (savedPosition) {
      return savedPosition;
    }

    // Cualquier navegación normal:
    // vuelve al inicio de la página.
    return {
      top: 0,
      left: 0,
      behavior: "auto",
    };
  },
});

router.afterEach((to) => {
  const label = to.name === "home"
    ? "Productos Chidos"
    : `${String(to.meta?.title ?? to.name ?? "Productos Chidos")} · Productos Chidos`;

  document.title = label;
});

export default router;
